import useFlag from './useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Hook to check if the billing and payment UCI payment refactor feature is enabled.
 * Moved from react-hooks to break circular dependency.
 *
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2024-12-13T14:45:42-0500.
 */
export function useBillingAndPaymentUciPaymentRefactorEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.BillingPaymentsUciPaymentRefactor,
    false
  );

  return Boolean(isEnabled);
}
